<script lang="ts">
	import { getClient, query as apolloQuery } from 'svelte-apollo';
	import LoadingOverlay from '../LoadingOverlay.svelte';

	export let query: any;

	const client = getClient();
	const operation = apolloQuery(client, { query: query });
</script>

{#await $operation}
	<slot name="loading">
		<LoadingOverlay title="Loading..." spinner />
	</slot>
{:then data}
	<slot response={data} />
{/await}
